export const TOUR_INSURANCES_BASE_KEY = 'tour-insurances';

export const tourInsurancesApiQueryKeys = {
  byTourId: (tourId: string) => [TOUR_INSURANCES_BASE_KEY, tourId] as const,
};
